//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Builder.js";
import "../GeometricUtilities/GeometricUtilities.PatternDefinition.js";
import "../no/SketchPattern.js";
import "../no/GeometricUtilities.js";
import "../no/Section.js";
let d=[[[0,"CreateConstraint",1,0],[0,"CreateSpacingExp",1,0],[0,"LockOrientation",1,0],[1,"PatternService",0,"GeometricUtilities.PatternDefinition",0],[0,"RelationScope",1,0],[0,"Section",0,"Section",0]],[[["parent","inx","isStart","constraint"],"SetEndConstraint",{},4,0],[[],"UpdateCopies",{},0,0],[[],"UpdateInputSection",{},0,0],[[],"UpdateLinearDirectionObject",{},0,0],[[],"UpdateCenterPoint",{},0,0],[[],"UpdateRectangularDirectionObjects",{},0,0],[[],"UpdateFromPoint",{},0,0],[[],"EvaluatePattern",{},0,0],[[],"UpdateData",{},0,0],[[],"HandleFlip",{},0,0],[["instanceXIndex","instanceYIndex","findRelations"],"SetRelationFinding",{},3,0],[["instanceXIndex","instanceYIndex"],"GetRelationFinding",{R_:{findRelations:''}},2,0]],[]];
SPLM.SketchPatternBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.SketchPatternBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;